export default function ServiceAreas() {
  const counties = [
    { name: 'Oakland County', color: '#0f766e', lightColor: '#99f6e4', cities: ['Troy', 'Rochester Hills', 'Farmington Hills', 'Royal Oak', 'Pontiac', 'Southfield', 'Auburn Hills', 'Bloomfield Hills', 'Clarkston', 'Clawson', 'Ferndale', 'Hazel Park', 'Highland', 'Holly', 'Keego Harbor', 'Lake Orion', 'Madison Heights', 'Milford', 'Novi', 'Oak Park', 'Orion Township', 'Oxford', 'Pleasant Ridge', 'Pontiac', 'Rochester', 'Sylvan Lake', 'Waterford', 'West Bloomfield', 'White Lake', 'Wixom', 'Walled Lake', 'Commerce Township'] },
    { name: 'Macomb County', color: '#0d9488', lightColor: '#5eead4', cities: ['Sterling Heights', 'Clinton Township', 'Shelby Township', 'St Clair Shores', 'Warren', 'Eastpointe', 'Roseville', 'Chesterfield Township', 'Harrison Township', 'Macomb Township', 'Mount Clemens', 'New Baltimore', 'New Haven', 'Richmond', 'Romeo', 'Utica', 'Washington Township', 'Fraser', 'Center Line', 'Armada', 'Ray Township', 'Bruce Township', 'Memphis'] },
    { name: 'Wayne County', color: '#14b8a6', lightColor: '#2dd4bf', cities: ['Detroit', 'Grosse Pointe', 'Dearborn', 'Livonia', 'Westland', 'Taylor', 'Canton', 'Plymouth', 'Allen Park', 'Belleville', 'Brownstown Township', 'Dearborn Heights', 'Ecorse', 'Flat Rock', 'Garden City', 'Gibraltar', 'Grosse Ile', 'Grosse Pointe Park', 'Grosse Pointe Woods', 'Hamtramck', 'Harper Woods', 'Highland Park', 'Huron Township', 'Inkster', 'Lincoln Park', 'Melvindale', 'Northville', 'Redford Township', 'River Rouge', 'Riverview', 'Rockwood', 'Romulus', 'Southgate', 'Trenton', 'Van Buren Township', 'Wayne', 'Woodhaven', 'Wyandotte'] },
    { name: 'Washtenaw County', color: '#5eead4', lightColor: '#ccfbf1', cities: ['Ann Arbor', 'Ypsilanti', 'Saline', 'Chelsea', 'Milan', 'Dexter', 'Pittsfield Township', 'Augusta Township', 'Bridgewater Township', 'Freedom Township', 'Lima Township', 'Lodi Township', 'Lyndon Township', 'Manchester', 'Northfield Township', 'Salem Township', 'Scio Township', 'Sharon Township', 'Superior Township', 'Sylvan Township', 'Webster Township', 'York Township', 'Ypsilanti Township'] },
  ];

  return (
    <section id="service-areas" className="py-16 sm:py-20 md:py-24 bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <span className="text-teal-400 text-sm font-bold tracking-wider uppercase">Where We Work</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-3 mb-4">
            Serving Southeast Michigan
          </h2>
          <p className="text-base sm:text-lg text-slate-300 max-w-2xl mx-auto">
            Proudly providing expert remodeling services throughout Metro Detroit and surrounding areas.
          </p>
        </div>

        {/* County Detail Cards only */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
          {counties.map((county, index) => (
            <div
              key={index}
              className="rounded-xl p-4 border border-white/10 hover:border-teal-400/50 transition-all duration-300"
              style={{ backgroundColor: `${county.color}22` }}
            >
              <div className="flex items-center gap-3 mb-3">
                <span
                  className="w-4 h-4 rounded-sm flex-shrink-0"
                  style={{ backgroundColor: county.color }}
                ></span>
                <h3 className="text-white font-bold text-base">{county.name}</h3>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {county.cities.map((city, idx) => (
                  <span
                    key={idx}
                    className="text-xs px-2 py-0.5 rounded-full text-slate-200"
                    style={{ backgroundColor: `${county.color}55` }}
                  >
                    {city}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* CTA Block */}
        <div className="bg-teal-600 rounded-2xl p-6 sm:p-8 md:p-12 text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">
            Not Sure If We Serve Your Area?
          </h3>
          <p className="text-white/90 text-base sm:text-lg mb-6 sm:mb-8 max-w-2xl mx-auto px-2">
            We work throughout Southeast Michigan. Give us a call to discuss your project location.
          </p>
          <a
            href="tel:586-443-0294"
            className="inline-flex items-center bg-white text-slate-900 px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base font-semibold hover:bg-slate-100 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Call 586-443-0294
          </a>
        </div>
      </div>
    </section>
  );
}
